var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4082 1H17.1607C18.4511 1 19.5001 2.04975 19.5001 3.34017V7.09267",
    stroke: "#545360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.09267V3.34017C0.5 2.04975 1.54896 1 2.83938 1H6.59188",
    stroke: "#545360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 13.9073V17.6598C19.5001 18.9503 18.4511 20 17.1607 20H13.4082",
    stroke: "#545360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59188 20H2.83938C1.54896 20 0.5 18.9503 0.5 17.6598V13.9073",
    stroke: "#545360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30072 9.70833H3.78261C3.2807 9.70833 2.875 9.33788 2.875 8.88142V4.20191C2.875 3.74546 3.2807 3.375 3.78261 3.375H8.30072C8.80263 3.375 9.20833 3.74546 9.20833 4.20191V8.88142C9.20833 9.33788 8.80172 9.70833 8.30072 9.70833Z",
    fill: "#B8B7C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17111 8.12504H4.91206C4.6611 8.12504 4.45825 7.93981 4.45825 7.71158V5.37183C4.45825 5.1436 4.6611 4.95837 4.91206 4.95837H7.17111C7.42207 4.95837 7.62492 5.1436 7.62492 5.37183V7.71158C7.62492 7.93981 7.42161 8.12504 7.17111 8.12504Z",
    fill: "#545360"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30072 17.625H3.78261C3.2807 17.625 2.875 17.2545 2.875 16.798V12.1185C2.875 11.6621 3.2807 11.2916 3.78261 11.2916H8.30072C8.80263 11.2916 9.20833 11.6621 9.20833 12.1185V16.798C9.20833 17.2545 8.80172 17.625 8.30072 17.625Z",
    fill: "#B8B7C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17111 16.0417H4.91206C4.6611 16.0417 4.45825 15.8564 4.45825 15.6282V13.2885C4.45825 13.0602 4.6611 12.875 4.91206 12.875H7.17111C7.42207 12.875 7.62492 13.0602 7.62492 13.2885V15.6282C7.62492 15.8564 7.42161 16.0417 7.17111 16.0417Z",
    fill: "#545360"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2175 9.70833H11.6994C11.1975 9.70833 10.7917 9.33788 10.7917 8.88142V4.20191C10.7917 3.74546 11.1975 3.375 11.6994 3.375H16.2175C16.7194 3.375 17.1251 3.74546 17.1251 4.20191V8.88142C17.1251 9.33788 16.7185 9.70833 16.2175 9.70833Z",
    fill: "#B8B7C3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0879 8.12504H12.8288C12.5779 8.12504 12.375 7.93981 12.375 7.71158V5.37183C12.375 5.1436 12.5779 4.95837 12.8288 4.95837H15.0879C15.3388 4.95837 15.5417 5.1436 15.5417 5.37183V7.71158C15.5417 7.93981 15.3384 8.12504 15.0879 8.12504Z",
    fill: "#545360"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2175 17.625H11.6994C11.1975 17.625 10.7917 17.2545 10.7917 16.798V12.1185C10.7917 11.6621 11.1975 11.2916 11.6994 11.2916H16.2175C16.7194 11.2916 17.1251 11.6621 17.1251 12.1185V16.798C17.1251 17.2545 16.7185 17.625 16.2175 17.625Z",
    fill: "#B8B7C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0879 16.0417H12.8288C12.5779 16.0417 12.375 15.8564 12.375 15.6282V13.2885C12.375 13.0602 12.5779 12.875 12.8288 12.875H15.0879C15.3388 12.875 15.5417 13.0602 15.5417 13.2885V15.6282C15.5417 15.8564 15.3384 16.0417 15.0879 16.0417Z",
    fill: "#545360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QrCode.7a7e20328eead5bf00c93862e9ab03b8.svg";
export { ForwardRef as ReactComponent };